import React from 'react';
import './Blogs.css'
import Cards from '../Shared/Cards/Cards'
import blog1 from '../../images/blog-1.jpg'
import blog2 from '../../images/blog-2.jpg'
import blog3 from '../../images/blog-3.jpg'
import blog5 from '../../images/blog-5.jpg'
import blog6 from '../../images/blog-6.jpg'
import blog7 from '../../images/blog-7.jpg'
import blog8 from '../../images/blog-8.jpg'

import test1 from '../../images/test-thumb4.jpg'

const Blogs = () => {
    return (
        <nav>
            <div className='blogs-nav'>
                <h2>Our Latest Medical<br />Blog Posts</h2>
            </div>

            <Cards></Cards>

            <div className='blog-cards'>

                <div className='blog-card'>
                    <div className='blog-card-header'>
                        <img src={blog1} alt="" />
                        <h4>Dolor clita vero elitr sea stet dolor justo diam</h4>
                        <p>Dolor lorem eos dolor duo et eirmod sea. Dolor sit magna rebum clita rebum dolor stet amet justo</p>
                    </div>

                    <div className='blog-card-footer'>
                        <div className='blog-card-footer-one'>
                            <img src={test1} alt="" />
                            <div className='blogs-author-part'>
                                <small>Author: <span><small className='blogs-author'>John Doe</small></span> </small>

                            </div>

                        </div>

                    </div>
                </div>



                <div className='blog-card'>
                    <div className='blog-card-header'>
                        <img src={blog2} alt="" />
                        <h4>Dolor clita vero elitr sea stet dolor justo diam</h4>
                        <p>Dolor lorem eos dolor duo et eirmod sea. Dolor sit magna rebum clita rebum dolor stet amet justo</p>
                    </div>

                    <div className='blog-card-footer'>
                        <div className='blog-card-footer-one'>
                            <img src={test1} alt="" />
                            <div className='blogs-author-part'>
                                <small>Author: <span><small className='blogs-author'>John Doe</small></span> </small>

                            </div>

                        </div>

                    </div>
                </div>



                <div className='blog-card'>
                    <div className='blog-card-header'>
                        <img src={blog3} alt="" />
                        <h4>Dolor clita vero elitr sea stet dolor justo diam</h4>
                        <p>Dolor lorem eos dolor duo et eirmod sea. Dolor sit magna rebum clita rebum dolor stet amet justo</p>
                    </div>

                    <div className='blog-card-footer'>
                        <div className='blog-card-footer-one'>
                            <img src={test1} alt="" />
                            <div className='blogs-author-part'>
                                <small>Author: <span><small className='blogs-author'>John Doe</small></span> </small>

                            </div>

                        </div>

                    </div>
                </div>


                <div className='blog-card'>
                    <div className='blog-card-header'>
                        <img src={blog5} alt="" />
                        <h4>Dolor clita vero elitr sea stet dolor justo diam</h4>
                        <p>Dolor lorem eos dolor duo et eirmod sea. Dolor sit magna rebum clita rebum dolor stet amet justo</p>
                    </div>

                    <div className='blog-card-footer'>
                        <div className='blog-card-footer-one'>
                            <img src={test1} alt="" />
                            <div className='blogs-author-part'>
                                <small>Author: <span><small className='blogs-author'>John Doe</small></span> </small>

                            </div>

                        </div>

                    </div>
                </div>



                <div className='blog-card'>
                    <div className='blog-card-header'>
                        <img src={blog6} alt="" />
                        <h4>Dolor clita vero elitr sea stet dolor justo diam</h4>
                        <p>Dolor lorem eos dolor duo et eirmod sea. Dolor sit magna rebum clita rebum dolor stet amet justo</p>
                    </div>

                    <div className='blog-card-footer'>
                        <div className='blog-card-footer-one'>
                            <img src={test1} alt="" />
                            <div className='blogs-author-part'>
                                <small>Author: <span><small className='blogs-author'>John Doe</small></span> </small>

                            </div>

                        </div>

                    </div>
                </div>



                <div className='blog-card'>
                    <div className='blog-card-header'>
                        <img src={blog7} alt="" />
                        <h4>Dolor clita vero elitr sea stet dolor justo diam</h4>
                        <p>Dolor lorem eos dolor duo et eirmod sea. Dolor sit magna rebum clita rebum dolor stet amet justo</p>
                    </div>

                    <div className='blog-card-footer'>
                        <div className='blog-card-footer-one'>
                            <img src={test1} alt="" />
                            <div className='blogs-author-part'>
                                <small>Author: <span><small className='blogs-author'>John Doe</small></span> </small>

                            </div>
                        </div>

                    </div>
                </div>


                <div className='blog-card'>
                    <div className='blog-card-header'>
                        <img src={blog8} alt="" />
                        <h4>Dolor clita vero elitr sea stet dolor justo diam</h4>
                        <p>Dolor lorem eos dolor duo et eirmod sea. Dolor sit magna rebum clita rebum dolor stet amet justo</p>
                    </div>

                    <div className='blog-card-footer'>
                        <div className='blog-card-footer-one'>
                            <img src={test1} alt="" />
                            <div className='blogs-author-part'>
                                <small>Author: <span><small className='blogs-author'>John Doe</small></span> </small>

                            </div>

                        </div>

                    </div>
                </div>


                <div className='blog-card'>
                    <div className='blog-card-header'>
                        <img src={blog1} alt="" />
                        <h4>Dolor clita vero elitr sea stet dolor justo diam</h4>
                        <p>Dolor lorem eos dolor duo et eirmod sea. Dolor sit magna rebum clita rebum dolor stet amet justo</p>
                    </div>

                    <div className='blog-card-footer'>
                        <div className='blog-card-footer-one'>
                            <img src={test1} alt="" />
                            <div className='blogs-author-part'>
                                <small>Author: <span><small className='blogs-author'>John Doe</small></span> </small>

                            </div>

                        </div>

                    </div>
                </div>


                <div className='blog-card'>
                    <div className='blog-card-header'>
                        <img src={blog1} alt="" />
                        <h4>Dolor clita vero elitr sea stet dolor justo diam</h4>
                        <p>Dolor lorem eos dolor duo et eirmod sea. Dolor sit magna rebum clita rebum dolor stet amet justo</p>
                    </div>

                    <div className='blog-card-footer'>
                        <div className='blog-card-footer-one'>
                            <img src={test1} alt="" />
                            <div className='blogs-author-part'>
                                <small>Author: <span><small className='blogs-author'>John Doe</small></span> </small>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Blogs;